import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { Users } from 'lucide-react';
export function Audience() {
  const {
    language
  } = useLanguage();
  const content = {
    en: {
      title: 'Built for early-career job seekers in the USA',
      desc: 'Entry-level and junior candidates often need to apply to more roles to get interviews. CV Go App supports that reality with:',
      points: ['job-specific tailoring at speed', 'professional output', 'simple exports (text + PDF)', 'bilingual support (EN/ES auto-detect)']
    },
    es: {
      title: 'Hecho para perfiles junior / early-career en USA',
      desc: 'Los perfiles entry-level y junior suelen tener que postular a más posiciones para lograr entrevistas. CV Go App acompaña esa realidad con:',
      points: ['adaptación específica por oferta en poco tiempo', 'salida profesional', 'exportación simple (texto + PDF)', 'soporte bilingüe (detección automática EN/ES)']
    }
  };
  const t = content[language];
  return <section className="py-16 bg-white border-t border-gray-100" data-id="element-2">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-3xl p-8 md:p-12 text-white text-center shadow-xl" data-id="element-4">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-white/20 rounded-full mb-6 backdrop-blur-sm" data-id="element-5">
            <Users className="w-6 h-6 text-white" data-id="element-6" />
          </div>

          <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-7">{t.title}</h2>
          <p className="text-blue-100 text-lg mb-8 max-w-2xl mx-auto" data-id="element-8">
            {t.desc}
          </p>

          <div className="grid sm:grid-cols-2 gap-4 text-left max-w-2xl mx-auto" data-id="element-9">
            {t.points.map((point, i) => <div key={i} className="flex items-center gap-3 bg-white/10 rounded-lg p-3 backdrop-blur-sm" data-id="element-10">
                <div className="w-2 h-2 bg-blue-200 rounded-full flex-shrink-0" data-id="element-11" />
                <span className="text-sm font-medium" data-id="element-12">{point}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}